import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class FacilityExtrastocksApi extends Api {
  constructor() {
    super('facility/extrastocks/');
  }

  getExcel = (params) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/facility/extrastocks.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };

  createRequest(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }
}

export default FacilityExtrastocksApi;
